import { gql } from "@apollo/client";

export const INVOICE_FIELDS = gql`
  fragment invoiceFields on Invoice {
    _id
    invoiceNumber
    issueDate
    status
    remark
    totalOwed
    amountPaid
    balance
    agent {
      _id
      displayName
    }
    lineItems {
      owedAmount
      employee {
        _id
        givenName
        surName
        passportNumber
        statusDates {
          departed
        }
        additionalData {
          appliedCountry
        }
      }
    }
    payments {
      amount
      paymentDate
      remark
    }
  }
`;

export const GET_ALL_INVOICES = gql`
  ${INVOICE_FIELDS}
  query invoices($agentId: String, $status: InvoiceStatus, $skip: Int, $take: Int) {
    invoices(agentId: $agentId, status: $status, skip: $skip, take: $take) {
      totalCount
      invoices {
        ...invoiceFields
      }
    }
  }
`;

export const GET_SELECTED_INVOICE = gql`
  ${INVOICE_FIELDS}
  query getInvoice($id: String!) {
    getInvoice(id: $id) {
      ...invoiceFields
    }
  }
`;

export const GET_UNINVOICED_DEPARTED_EMPLOYEES = gql`
  query uninvoicedDepartedEmployees($agentId: String!) {
    uninvoicedDepartedEmployees(agentId: $agentId) {
      _id
      givenName
      surName
      passportNumber
      statusDates {
        departed
      }
      additionalData {
        appliedCountry
      }
      agentSettlement {
        owedAmount
        reportedAmount
      }
    }
  }
`;

export const GET_GOVERNMENT_REPORT = gql`
  query governmentReport($startDate: DateTime!, $endDate: DateTime!) {
    governmentReport(startDate: $startDate, endDate: $endDate) {
      totalCount
      totalReported
      countryTotals {
        country
        count
        total
      }
      employees {
        _id
        givenName
        surName
        passportNumber
        statusDates {
          departed
        }
        additionalData {
          appliedCountry
        }
        agentSettlement {
          owedAmount
          reportedAmount
        }
        partner {
          _id
          displayName
        }
      }
    }
  }
`;

export const GET_GOV_REPORT_RATES = gql`
  query govReportRates {
    govReportRates {
      _id
      country
      amount
    }
  }
`;
